import DateAndTime from '../../Header/DateAndTime';

const Time: React.FC = () => {
  return (
    <div className="time">
      <DateAndTime></DateAndTime>
    </div>
  );
};

export default Time;
